import React from 'react'
import {useSelector} from 'react-redux'

import {
    PaginationDashboard,
    typePaginationDashboardObject
} from '../PaginationDashboard/PaginationDashboard'
import {Loader} from 'components/UI/Loader/Loader'

import {ISystemState} from 'model/system/systemReducer'


// Type
export type typeDataTableDashboard = {
    tableHeader: React.ReactElement | []
    tableBody: React.ReactElement | []
    pagination?: typePaginationDashboardObject
}


// Component
export const DataTableDashboard: React.FC<typeDataTableDashboard> = ({tableHeader, tableBody, pagination}) => {

    const dashboardLoader = useSelector((state:{system: ISystemState}) =>state.system.dashboardLoader)

    return(
        <div className="relative">

            <div className="flex flex-col">
                <div className="-my-2 overflow-x-auto">
                    <div className="py-2 align-middle inline-block min-w-full">
                        <div className="overflow-hidden border border-gray-200 shadow-sm sm:rounded-lg">

                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-primary-50 text-gray-800">
                                    <tr className="relative bg-primary-50 ">
                                        {tableHeader}
                                    </tr>
                                </thead>
                                <tbody className="divide-y">
                                    {tableBody}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>

            { pagination ? <PaginationDashboard pagination={pagination}/> : null}

            {dashboardLoader ? <Loader/> : null}

        </div>
    )
}
